/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EncryptKey } from '../../config/constants';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) { }

  public saveData(key: string, value: any): void {
    if (isPlatformBrowser(this.platformId)) localStorage.setItem(key, value);
  }

  public getData(key: string): string | null {
    return isPlatformBrowser(this.platformId) ? localStorage.getItem(key) : '';
  }

  public saveEncryptData(key: string, value: any): void {
    if (isPlatformBrowser(this.platformId)) localStorage.setItem(key, this.encrypt(value));
  }

  public getEncryptData(key: string): string {
    const data = isPlatformBrowser(this.platformId) ? localStorage.getItem(key) || "" : '';
    return this.decrypt(data);
  }
  public removeData(key: string): void {
    localStorage.removeItem(key);
  }

  public clearData(): void {
    localStorage.clear();
  }

  private encrypt(txt: any): string {
    return CryptoJS.AES.encrypt(txt, EncryptKey).toString();
  }

  private decrypt(txtToDecrypt: any): string {
    return CryptoJS.AES.decrypt(txtToDecrypt, EncryptKey).toString(CryptoJS.enc.Utf8);
  }
}
